import {
  IOriginEvents,
  TOPICS,
  eventListener,
} from "@origin-digital/event-dispatcher";
import { Dialog } from "@origin-digital/ods-core";
import React, { useEffect, useState } from "react";

const SURVEY_BASE_PATH = "/my/survey";

export const Survey = () => {
  const [showSurvey, setShowSurvey] = useState(false);
  const [payload, setPayload] = useState({});
  const [path, setPath] = useState("");
  const queryParams = new URLSearchParams(payload).toString();

  useEffect(() => {
    const dialogOpenUnsubscribe = eventListener.addListener(
      TOPICS.SURVEY_OPEN,
      (event: IOriginEvents) => {
        if (event.topic === TOPICS.SURVEY_OPEN) {
          setShowSurvey(true);
          setPayload(event.payload);
        }
      }
    );
    return dialogOpenUnsubscribe;
  }, []);

  useEffect(() => {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    window.onmessage = (event: any) => {
      if (event?.data?.topic === TOPICS.SURVEY_CLOSE) {
        setShowSurvey(false);
      }
    };
  }, []);

  useEffect(() => {
    if (window) {
      setPath(window.location.origin);
    }
  }, []);

  return (
    /**
     * This dialog has no title or close button, padding is set to be 0
     * All layout is handled by microsite in iframe
     */
    <Dialog
      id="survey-dialog"
      open={showSurvey}
      title={null}
      onClose={() => setShowSurvey(false)}
      hideClose
      aria-labelledby="survey-title"
      muiProps={{
        titleProps: { hidden: true },
        contentProps: { style: { padding: 0, height: "80vh" } },
      }}
    >
      <iframe
        src={`${path}${SURVEY_BASE_PATH}?${queryParams}`}
        data-id="survey-iframe"
        id="survey-iframe"
        title="Survey"
        width="100%"
        height="99%"
        frameBorder="0"
      />
    </Dialog>
  );
};
